export const GATE_KEYS = ['tenantPush', 'tenantType', 'category', 'device'];
export const ROW_FILTERS = ['all', 'both', 'rails_only', 'platform_only'];
